module.exports = __webpack_public_path__ + "static/img/finance.ab80675.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/finance.jpg?20181011
// module id = 8R+9
// module chunks = 1